export default "__VITE_ASSET__c37f1384__"